<template>
  <div>
    <!--导航栏 start-->
    <div class="nav-bar">
      <van-nav-bar left-text="返回" fixed title="支付宝认证" left-arrow @click-left="onClickLeft"></van-nav-bar>
    </div>
    <!--导航栏 end-->
    <div class="box">
      <van-field
        v-model="fieldValue"
        is-link
        readonly
        label="地区"
        placeholder="请选择所在地区"
        @click="show = true"
        required
        :rules="[{ required: true, message: '省区县必选' }]"
      />
      <van-popup v-model="show" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          @close="show = false"
          @finish="onFinish"
        />
      </van-popup>
      <div style="margin: 16px">
        <van-button round block type="info" @click="submit">确定</van-button>
      </div>

      <img :src="imageUrl" alt v-if="imageUrl" />
      <div v-if="state == 'CONTACT_CONFIRM'" class="shnehezhong">待联系人确认</div>
      <div v-if="state == 'LEGAL_CONFIRM'" class="shnehezhong">待法人确认</div>
      <div v-if="state == 'AUDITING'" class="shnehezhong">审核中</div>
      <div class="shnehezhong" v-if="state == 'AUDIT_PASS'">审核已通过</div>
      <div class="shnehezhong" v-if="state == 'AUDIT_REJECT'">审核失败</div>
      <div class="shnehezhong" v-if="state == 'AUDIT_FREEZE'">已冻结</div>
      <div class="shnehezhong" v-if="state == 'CANCELED'">已撤回</div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Notify } from "vant";
import QRCode from "qrcodejs2";
import { zfbArea } from "@/assets/json/zfb_area";

export default {
  components: {
    // vueQr,
  },
  data() {
    return {
      query: "",
      imageUrl: "",
      state: "",
      show: false,
      options: zfbArea,
      fieldValue: "",
      cascaderValue: "",
      province_code: "",
      city_code: "",
      district_code: "",
      province: "",
      city: "",
      district: "",
    };
  },
  mounted() {
    console.log("-----", JSON.parse(this.$route.query.form));
    this.query = JSON.parse(this.$route.query.form);
    console.log(this.query);
  },
  methods: {
    // 返回上一级
    onClickLeft() {
      this.$router.go(-1);
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      console.log("-----", selectedOptions);
      this.province_code = selectedOptions[0].value;
      this.province = selectedOptions[0].text;
      this.city_code = selectedOptions[1].value;
      this.city = selectedOptions[1].text;
      this.district_code = selectedOptions[2].value;
      this.district = selectedOptions[2].text;
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    submit() {
      if (!this.province_code) {
        Toast("请选择省市区");
        return;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      this.$http
        .get("/wechat/api.merchant/merchantAuth", {
          params: {
            merchant_id: this.query.id,
            type: this.query.type,
            province_code: this.province_code,
            city_code: this.city_code,
            district_code: this.district_code,
            province: this.province,
            city: this.city,
            district: this.district,
          },
        })
        .then((response) => {
          console.log(response);
          Toast.clear();
          if (response && response.data.code == 200) {
            // this.$nextTick(() => {
            //   this.creatQrCode(response.data.data.qr_code);
            // });
            this.imageUrl = response.data.data.qr_code;
            // console.log(this.imageUrl);
            this.state = response.data.data.order_status;
          } else {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
    creatQrCode(text) {
      console.log("======", text);
      console.log(this.$refs.qrcode);
      var qrcode = new QRCode("qrcode", {
        text: text, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      console.log(qrcode);
    },
  },
};
</script>
<style scoped>
.box {
  margin: 20px;
  text-align: center;
  padding-top: 46px;
}
.img {
  width: 200px;
  height: 200px;
}
.shnehezhong {
  font-size: 16px;
}
</style>